<template>
  <div>
    <el-dialog
      class="edit-dialog"
      title="编辑操作员"
      ref="ruleForm"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      @close="cancel"
    >
      <div class="content">
        <!-- <div class="con-title">
          <span>编辑操作员</span>
        </div> -->
        <div class="form-content">
          <div class="cont-item">
            <div class="cont-name">代理人 ：</div>
            <div class="cont-info">
              <el-select v-model="state1" filterable placeholder="请选择">
                <el-option
                  v-for="item in agents"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="danger" size="small" @click="cancel()">取消</el-button>
        <el-button type="primary" size="small" @click="editCallback()"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 *
 * props 参数buttons
 * eventKey:通过key在回调中处理按钮事件 type:按钮样式类型 checkSubmit:是否需要绑定提交指令
 * 例：{ label: "确定", eventKey: "submit", type: "primary" ,checkSubmit:true},
 * props 参数 Array:renderList
 * [{title:'连锁店信息',data:[{name:'name',title:'名称'}]}]
 */
export default {
  name: "SelectDialog",
  props: {
    // buttons: {
    //   type: Array,
    //   default: () => [
    //     { label: "取消", eventKey: "cancel" },
    //     {
    //       label: "确定",
    //       eventKey: "submit",
    //       type: "primary",
    //       checkSubmit: true,
    //     },
    //   ],
    // },
    selectVisible: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      agents: [],
      state1: "",
      dialogFormVisible: this.selectVisible
    };
  },
  //   data() {
  //     return {
  //       dialogFormVisible: this.selectVisible,
  //     };
  //   },
  methods: {
    cancel() {
      this.$emit("update:selectVisible", false);
    },
    editCallback() {
      this.$axios
        .post(
          this.$server + "/hrStaff/agentBind",
          this.$qs.stringify({
            serialId: this.data.serialId,
            memId: this.state1
          })
        )
        .then(res => {
          if (res.data.code == "0") {
            this.$message.success("绑定成功");
            this.$emit("update:selectVisible", false);
          } else {
            this.$message.error(res.data.message);
          }
        });
    }
  },
  mounted() {
    this.$axios
      .post(this.$server + "/agent/agentInfoList", this.$qs.stringify({}))
      .then(res => {
        if (res.data.code == "0") {
          this.agents = res.data.data.map(v => {
            return { label: v.fullName, value: v.memId };
          });
        } else {
          this.$message.error(res.data.message);
        }
      });
  }
  //   created() {},
};
</script>
<style lang="scss" scoped>
.CustomerTitle {
  color: #000;
  text-align: left;
  padding-left: 140px;
  margin-bottom: 15px;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
.con-title {
  text-align: left;
  margin-bottom: 10px;
  span {
    border-bottom: 2px #409eff solid;
    line-height: 30px;
    padding: 5px 0;
  }
}
.form-content {
  padding-left: 30px;
  margin-bottom: 10px;
  margin-top: 10px;
}
.cont-item {
  height: 40px;
  line-height: 40px;
  .cont-name {
    float: left;
    margin-right: 20px;
    width: 120px;
    text-align: left;
  }
  .cont-info {
    float: left;
  }
}
.idCard {
  height: 200px !important;
  img {
    border: 1px #ddd dashed;
    background: #def5ff66;
    width: 380px;
    height: 180px;
    float: left;
  }
}
.avatar {
  height: 200px !important;
  img {
    width: 180px;
    border: 1px #ddd dashed;
    background: #def5ff66;
    height: 180px;
    float: left;
  }
}
</style>
<style>
.check-dialog .el-dialog {
  width: 50%;
  max-width: 700px;
}
.check-dialog .el-dialog__header {
  display: none;
}
.inline-input {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/page/SelectDialog.vue